import { gql } from 'apollo-angular';

export const removeFichierOperationMutation = gql`
  mutation removeFichierOperationFromOperation($fichierOperationId: ID!) {
    removeFichierOperationFromOperation(fichierOperationId: $fichierOperationId) {
      id
    }
  }
`;
